module.exports = __webpack_public_path__ + "img/6.32b2d090.jpg";